import Collapse from './Collapse';

export default Collapse;
export var Panel = Collapse.Panel;


//////////////////
// WEBPACK FOOTER
// ../~/rc-collapse/es/index.js
// module id = 740
// module chunks = 1